export enum State {
    Traversing,
    Waiting,
    WaitingInteractively,
}

export default State;
